import type { Section } from '../model/pages';
import { normalizeSectionDesign } from '../model/section-design';

/** Shared visual settings only. Copying a look never overwrites words, links,
 * anchors, visibility, or a section type's content/layout choices. */
export const SECTION_STYLE_KEYS = [
  'design', 'align', 'bg', 'inset', 'text_size', 'space', 'space_below',
  'animation', 'bg_image_url', 'bg_overlay',
] as const satisfies readonly (keyof Section)[];

export function resetSectionStylePatch(): Partial<Section> {
  return Object.fromEntries(SECTION_STYLE_KEYS.map((key) => [key, undefined]));
}

/** Include empty values to replace, rather than accidentally merge, the target's
 * previous style. Keep an independent copy while the source is being edited. */
export function sectionStylePatch(section: Partial<Section>): Partial<Section> {
  return {
    ...Object.fromEntries(SECTION_STYLE_KEYS.map((key) => [key, section[key]])),
    design: normalizeSectionDesign(section.design),
  };
}
